module.exports = __webpack_public_path__ + "img/asdep-no-bg.997cf4e7.png";